import { useWindows } from '@app/contexts/WindowContext';
import { WINDOWS } from '@components/Window/windows';

import style from './style.module.css';

const CrossCancel = ({ cancelCallback }) => {
    const { actions } = useWindows();

    if (!cancelCallback) {
        return null;
    }

    const onClick = () => {
        actions.open(WINDOWS.QUIT, {
            handleCancel: () => actions.close(),
            handleConfirm: () => window.location.href = cancelCallback,
        });
    }

    return <span onClick={onClick} className={style.close} />
}

export default CrossCancel;